export default __webpack_public_path__ + "static/Karta-prvej-pomoci-b61e967b10cb7e29eb1ddb845c07b219.pdf";